import { useEffect, useState } from "react";

/**
 * Mirrors `active` but lags the rising edge by `delay` ms: turns `true` only after `active`
 * has stayed `true` for `delay` ms, and turns `false` immediately when `active` becomes `false`.
 * Useful to avoid flashing UI for fast operations while still reacting to slow ones.
 */
const useDelayedFlag = (active: boolean, delay = 0): boolean => {
    const [isDelayed, setIsDelayed] = useState(false);

    useEffect(() => {
        if (!active) {
            setIsDelayed(false);
            return;
        }

        const timeoutId = setTimeout(() => setIsDelayed(true), delay);

        return () => clearTimeout(timeoutId);
    }, [active, delay]);

    return isDelayed;
};

export default useDelayedFlag;
